var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.count !== 0)?_c('v-pager',{attrs:{"limit":_vm.limit,"results":_vm.count,"endpoint":_vm.path}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }